<div class="row align-items-center justify-content-center pt-5 px-3">
    <div class="col-12">
        <h1>We merken dat je Park the Sun op een klein apparaat bekijkt. De applicatie is beschikbaar voor tablets en
            grotere apparaten (>768px). We zien je zo graag terug op een groter apparaat!</h1>
    </div>
</div>